
<template>
  <div>
    <v-row>
      <v-col class="min-width-7">
        <!-- Proble Type -->
        <v-row>
          <v-col cols="4" class="pb-0" style="max-width: 120px">
            <label class="font-weight-bold">{{ $t("PROBLEM_TYPE") }}</label>
          </v-col>
          <v-col class="pb-0">
            <label>{{ probleType.find((e) => e.key == isValue).text }}</label>
          </v-col>
        </v-row>

        <component :is="`Form${isValue}`" ref="form" :parent="parent" />
      </v-col>
      <v-col class="min-width-3 max-width-4 ml-10">
        <div class="template-show pa-3">
          <component :is="`Template${isValue}`" :no="this.$route.query.no" />
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-btn color="primary" class="ml-10" @click="checkValidate">{{
        $t("UPDATE")
      }}</v-btn>
      <Dialog v-model="dialogConfirmUpdate" :title="$t('COMFIRMATION')">
        <template v-slot:content>更新します。よろしいですか。</template>
        <template v-slot:actions>
          <v-btn color @click="dialogConfirmUpdate = false" small>{{
            $t("CANCEL")
          }}</v-btn>
          <v-btn
            :disabled="loaddingUpdateGeneral"
            color="primary"
            small
            :loading="loaddingUpdateGeneral"
            @click="handleUpdateQuestion"
            >{{ $t("OK") }}</v-btn
          >
        </template>
      </Dialog>

      <v-btn color class="ml-10" @click="back">{{ $t("BACK") }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import { getDetailQuestion, updateQuestion } from "@/api/Question.api";
import uploadFile from "@/utils/uploadFile";
import mixin from "@/mixin";
import { FormBuilder } from "@/views/listGeneral/formbuilder.js";
export default {
  components: FormBuilder.$options.components,
  store: ["formGeneral"],
  mixins: [mixin.ValidateGeneral],
  data() {
    return {
      probleType: [
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
      ],
      dialogConfirmUpdate: false,
      isValue: "Choices",
      loaddingUpdateGeneral: false,
    };
  },
  computed: {
    parent() {
      var parent = "";
      if (
        this.$route.name == "Create General OF Season" ||
        this.$route.name == "Update General OF Season"
      ) {
        parent = "season";
      } else if (
        this.$route.name == "Create General OF Chapter" ||
        this.$route.name == "Update General OF Chapter"
      ) {
        parent = "chapter";
      } else if (
        this.$route.name == "Create General OF Section" ||
        this.$route.name == "Update General OF Section"
      ) {
        parent = "section";
      }
      console.log(parent);
      return parent;
    },
  },
  async created() {
    if (this.$route.name !== "Create General OF Section") {
      this.probleType.push(
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" }
      );
    }
    console.log("this.$route.query.no: ",this.$route.query.no)
    await this.handleGetDetail();
  },
  methods: {
    async handleGetDetail() {
      let params = {
        sub_key: this.$route.params[this.parent],
        id: this.$route.params.id,
        parent: this.parent,
      };
      await getDetailQuestion(params).then((response) => {
        const {
          type_value,
          name,
          lead_sentence,
          verb,
          list_answer,
          answer_correct,
          script,
          image,
          image_url,
          audio,
          audio_url,
          sub_question: { question1, question2 },
        } = response.result;
        this.itemDetail = response.result;
        this.isValue = type_value;
        this.formGeneral.leadSentence = lead_sentence;
        // If type = Choices || Sort
        if (type_value == "Choices" || type_value == "Sort") {
          if (typeof name[0] == "string") {
            this.formGeneral.name = [name];
          } else {
            this.formGeneral.name = name;
          }
          console.log("this.formGeneral.name: ", this.formGeneral.name);
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
          this.formGeneral.isAnsewr = answer_correct[0];
        }
        // If type = Conjugation
        if (type_value == "Conjugation") {
          this.formGeneral.name1 = list_answer.sentence_answer[0];
          this.formGeneral.name2 = list_answer.sentence_answer[1];
          this.formGeneral.verb = verb;
          this.formGeneral.answersConjugation = list_answer.answer[0];
          this.formGeneral.wrongAnswersConjugation = list_answer.answer[1];
          this.formGeneral.isAnsewr = answer_correct[0];
        }
        // If type = kanji
        if (type_value == "Kanji") {
          this.formGeneral.name1 = name[0][0];
          this.formGeneral.kanji = name[0][1];
          this.formGeneral.name2 = name[0][2];
          this.formGeneral.isAnsewr = answer_correct[0];
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }

        // If type = ShortSentences
        if (type_value == "ShortSentences") {
          this.formGeneral.isAnsewr = answer_correct[0];
          console.log("script: ", script);
          this.formGeneral.script = script;
          this.formGeneral.audio = audio_url
            ? { fileUrl: audio_url, file_name: audio }
            : null;
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }

        // If type = LongSentences
        if (type_value == "LongSentences") {
          this.formGeneral.audio = audio_url
            ? { fileUrl: audio_url, file_name: audio }
            : null;
          this.formGeneral.script = script;
          this.formGeneral.sub_question.question1 = question1;
          this.formGeneral.sub_question.question2 = question2;

          this.formGeneral.sub_question.question1.audio = question1.audio_url
            ? { fileUrl: question1.audio_url, file_name: question1.audio }
            : null;
          this.formGeneral.sub_question.question2.audio = question2.audio_url
            ? { fileUrl: question2.audio_url, file_name: question2.audio }
            : null;
        }

        // If type = Comprehension
        if (type_value == "Comprehension") {
          this.formGeneral.name1 = name[0][0];
          this.formGeneral.name2 = name[0][1];
          this.formGeneral.isAnsewr = answer_correct[0];
          this.formGeneral.image = image_url
            ? { fileUrl: image_url, file_name: image }
            : null;
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }
        // If type = MultiRead
        if (type_value == "MultiRead") {
          this.formGeneral.name1 = name[0][0];
          this.formGeneral.name2 = name[0][1];
          this.formGeneral.isAnsewr = answer_correct;
          this.formGeneral.image = image_url
            ? { fileUrl: image_url, file_name: image }
            : null;
          this.formGeneral.answers.forEach(
            (e, index) => (e.value = response.result[`answer${index + 1}`])
          );
        }
      });
    },
    async handleUpdateQuestion() {
      this.loaddingUpdateGeneral = true;
      let params = await this.$refs.form.getParams();
      if (params) {
        params.type_value = this.isValue;
        params.id = this.$route.params.id;
        params = await this.checkFile(params);
        await updateQuestion(params)
          .then(async () => {
            this.dialogConfirmCreate = false;
            this.back();
          })
          .catch((error) => {
            this.loaddingUpdateGeneral = false;
            this.$toast.error(error);
          });
      } else {
        this.loaddingUpdateGeneral = false;
        this.dialogConfirmUpdate = false;
      }
    },
    async checkFile(params) {
      if (params.audio && params.audio.file) {
        await uploadFile(params.audio.file, "audio").then((e) => {
          params.audio = e;
        });
      } else if (params.audio && !params.audio.file && params.audio.file_name) {
        params.audio = params.audio.file_name;
      }
      if (params.image && params.image.file) {
        await uploadFile(params.image.file, "image").then((e) => {
          params.image = e;
        });
      } else if (params.image && !params.image.file && params.image.file_name) {
        params.image = params.image.file_name;
      }
      if (
        params.sub_question.question1.audio &&
        params.sub_question.question1.audio.file
      ) {
        await uploadFile(
          params.sub_question.question1.audio.file,
          "audio"
        ).then((e) => {
          params.sub_question.question1.audio = e;
        });
      } else if (
        params.sub_question.question1.audio &&
        !params.sub_question.question1.audio.file &&
        params.sub_question.question1.audio.file_name
      ) {
        params.sub_question.question1.audio =
          params.sub_question.question1.audio.file_name;
      }
      if (
        params.sub_question.question2.audio &&
        params.sub_question.question2.audio.file
      ) {
        await uploadFile(
          params.sub_question.question2.audio.file,
          "audio"
        ).then((e) => {
          params.sub_question.question2.audio = e;
        });
      } else if (
        params.sub_question.question2.audio &&
        !params.sub_question.question2.audio.file &&
        params.sub_question.question2.audio.file_name
      ) {
        params.sub_question.question2.audio =
          params.sub_question.question2.audio.file_name;
      }
      return params;
    },
    async checkValidate() {
      let params = await this.$refs.form.getParams();
      if (params) {
        this.dialogConfirmUpdate = true;
      }
    },
    back() {
      const { query } = this.$route;
      if (this.parent == "season") {
        this.$router.push({
          name: "List General OF Season",
          params: { season: this.$route.params.season },
          query,
        });
      }
      if (this.parent == "chapter") {
        this.$router.push({
          name: "List General OF Chapter",
          params: { season: this.$route.params.chapter },
          query,
        });
      }
      if (this.parent == "section") {
        this.$router.push({
          name: "List General OF Section",
          params: { season: this.$route.params.section },
          query,
        });
      }
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      name: [["", ""]],
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>
<style>
.col-lable {
  min-width: 120px;
  max-width: 120px;
}
</style>
<style lang="scss" scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}
.template-show {
  border: 1px solid #ccc;
}
</style>